import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { Pdf as PdfBase } from '@trinity/chat-components/components/Pdf/index.js';
import { ProgressOverlay } from '@/components/presentation/ProgressOverlay';
import styles from './style.module.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

type Props = {
  url: string;
  page?: number;
};

export const Pdf = ({ url, page }: Props) => {
  return (
    <PdfBase
      url={url}
      page={page}
      loadingContent={(progress) => (
        <div className={styles.progress}>
          <ProgressOverlay progress={progress} />
        </div>
      )}
      pageLoadingContent={() => (
        <div className={styles.pageLoading}>
          <ProgressOverlay progress={75} />
        </div>
      )}
    />
  );
};
